import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.addEventListener("toggle", this.#onToggle);
    this.element.addEventListener("focusout", this.#onFocusOut);
  }

  disconnect() {
    this.element.removeEventListener("toggle", this.#onToggle);
    this.element.removeEventListener("focusout", this.#onFocusOut);
  }

  open() {
    this.element.setAttribute("open", "");
    this.element.querySelector("summary").setAttribute("aria-expanded", true);
  }

  close() {
    this.element.removeAttribute("open");
    this.element.querySelector("summary").setAttribute("aria-expanded", false);
  }

  #onFocusOut = () => {
    setTimeout(() => {
      if (!this.element.contains(document.activeElement)) this.close();
    })
  }

  #onToggle = () => {
    if (this.element.open) {
      this.open();
    } else {
      this.close();
    }
  }
}
